import axios from 'axios';
// import { store } from '../store';
import { fmtPlan } from '../common/utils/format';

export function getPlan(planID) {
  const token = localStorage.getItem('SessionToken');
  return axios({
    method: 'get',
    url: `${process.env.REACT_APP_MMB_API_URL}/api/utils/plans/${planID}/`,
    headers: { Authorization: `Token ${token}` },
  })
    .then(({ data }) => fmtPlan(data));
}

export function getAdditionalPlanInfo(planID, countyFips) {
  const token = localStorage.getItem('SessionToken');
  return axios({
    method: 'get',
    url: `${process.env.REACT_APP_MMB_API_URL}/api/utils/plan/${planID}/${countyFips}/customerplan/`,
    headers: { Authorization: `Token ${token}` },
  })
    .then(({ data }) => data[0] || {})
    .catch(() => {});
}
